module.exports = "/_next/static/images/32-1-ad95c41ac4728c287166738df3102992.jpg";